import React from "react";
import "./AboutFolder.css"
import pdf from '../../images/CVNicolasMarquez.pdf'

const AboutFolder = () => {
    return(
        <div className="about">
            <div>
                <p>
                    Soy estudiante de la carrera de Tecnólogo en Informática dictada por la Universidad de la República y UTU,
                    actualmente curso el 4to semestre.
                     Me considero un apasionado por la informática, el desarrollo de software y la tecnología en general.<br></br><br></br>

                    Trabajé como Support Engineer para Microsoft, resolviendo problemas
                    de alta complejidad, adquiriendo habilidades que puedo aplicar en diferentes ámbitos.<br></br>
                    Realicé páginas web para diversas empresas, entregando un trabajo de calidad y satisfaciendo las expectativas del cliente.
                </p> <br />
                <p>
                    Me considero una persona de carácter responsable y compañero. Disfruto el constante aprendizaje y aporte que me puedan brindar otras personas 
                    y estoy preparado para nuevos desafíos que me aportarán tanto a nivel profesional como personal.
                </p>
            </div>
            <div className="buttons">
                <button className="linkedin">
                    <a href="https://www.linkedin.com/in/nicolas-marquez-/" target="_blank">LinkedIn</a>
                </button>
                <button className="cv">
                    <a href={pdf} target="_blank" rel="noopener noreferrer" download="NicolasMarquezCV">CV</a>
                </button>
            </div>
        </div>
    )
}

export default AboutFolder